import { render, staticRenderFns } from "./PorletVisorPDF.vue?vue&type=template&id=5e8d1b0b"
import script from "./PorletVisorPDF.vue?vue&type=script&lang=js"
export * from "./PorletVisorPDF.vue?vue&type=script&lang=js"
import style0 from "./PorletVisorPDF.vue?vue&type=style&index=0&id=5e8d1b0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports